import { Typography } from "@mui/material";
import styled from "styled-components";

export const Title = styled(Typography)`
  && {
    font-family: "Figtree", "Roboto", "sans-serif";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #ffffff;

    @media (max-width: 1280px) {
      font-size: 15px;
    }

    @media (max-width: 1024px) {
      font-size: 13px;
    }
  }
`;